import { api } from "../scripts/api.js";

class AppCreateAssignment extends HTMLElement {
   connectedCallback() {
      this.innerHTML = `
         <section>
            <header class="create-assignment-header">
               <h1>Create Assignment</h1>
            </header>

            <!-- new layout below here -->

         </section>
      `

   }

}

customElements.define("app-create-assignment", AppCreateAssignment);